export default {
  async fetchSettings(axios, token) {
    return await axios.get(`/api/business/dashboard-settings/me/`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  },
  buildUpdate(language, notificationsLevel) {
    return {
      'data': {
        'attributes': {
          'language': language,
          'notifications-level': notificationsLevel,
        },
        'type': 'dashboard-settings',
      },
    };
  },
  async updateSettings(axios, token, data) {
    return await axios.patch(`/api/business/dashboard-settings/me/`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  },
};
